/**
 * DeliverySacRequest
 * @author ftgibran
 */
import {
  IResource,
  Model,
  ResponseFill,
  HttpIgnore,
  ObjectCollection,
  Collection,
  ValidationRequired,
} from 'simpli-web-sdk'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {ItrackCollection} from '@/helpers'
import {Period} from '@/enums/Period'
import moment from 'moment'
import OcorrenciaTracking from '@/model/resource/OcorrenciaTracking'
import * as Helper from '@/helpers/custom.helper'

@HttpIgnore()
export default class DeliverySacRequest extends Model {
  readonly $name: string = 'DeliverySacRequest'

  @ResponseFill('query')
  documentDestinatario: string | null = null

  @ResponseFill('nroFiscal')
  docs: string | null = null

  @ResponseFill('cte')
  cte: string | null = null

  @ResponseFill('idTipoOcorrencia')
  idTipoOcorrencia: number| null = null

  @ResponseFill()
  @ValidationRequired()
  date: string = moment().format()

  @ResponseFill()
  @ValidationRequired()
  period = Period.HOURLY

  @ResponseFill('idOcorrenciaTracking')
  idOcorrenciaTracking: number| null = null

  @ResponseFill('idInsumo')
  @ValidationRequired()
  idInsumo: number | null = null

  @ResponseFill('searchByCTE')
  searchByCTE: string | null = null

  @ResponseFill('manifesto')
  manifesto: string | null = null

  @ResponseFill('nomeDestinatario')
  nomeDestinatario: string | null = null

  @ResponseFill('idCarga')
  idCarga: number | null = null

  allDocs = new ObjectCollection()
  allTipoOcorrencia = ItrackCollection.allTipoOcorrenciaFiltro
  tipoOcorrenciaNaoDevolvidaCollection = new Collection(TipoOcorrencia)
  tipoOcorrenciaDevolvidaCollection = new Collection(TipoOcorrencia)
  periodCollection = ItrackCollection.getPeriodCollection()
  periodCollectionNoWeekly = ItrackCollection.getPeriodCollectionWithNoWeekly()
  monthCollection = ItrackCollection.getMonthCollection()
  yearCollection = ItrackCollection.getYearCollection()
  allOcorrenciaTracking = ItrackCollection.allOcorrenciaTracking
  ocorrenciaTrackingCollection = new Collection(OcorrenciaTracking)
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allCte = new ObjectCollection()

  get docsResource() {
    const str = String(this.docs || '')
    const docs = str.split(',')
    return this.allDocs.getMany(docs)
  }
  set docsResource(val: IResource[]) {
    this.docs = val.map((item: IResource) => item.$id).join(',')
  }

  get isCleared() {
    return !(this.documentDestinatario || this.docs || this.cte || this.allTipoOcorrencia)
  }

  populateAllDocs(val: IResource[]) {
    this.allDocs = new ObjectCollection(val)
  }

  get tipoOcorrenciaResource() {
    return this.tipoOcorrenciaNaoDevolvidaCollection.get(this.idTipoOcorrencia)
  }
  set tipoOcorrenciaResource(val: IResource | null) {
    this.idTipoOcorrencia = val && val.$id as number || null
  }

  get ocorrenciaTrackingResource() {
    return this.ocorrenciaTrackingCollection.get(this.idOcorrenciaTracking)
  }
  set ocorrenciaTrackingResource(val: IResource | null) {
    this.idOcorrenciaTracking = val && val.$id as number || null
  }

  get dayCollection() {
    return ItrackCollection.getDayCollection(this.date)
  }

  get periodResource() {
    return this.periodCollection.get(this.period)
  }
  set periodResource(val: IResource | null) {
    this.period = val && val.$id as Period || Period.DAILY
  }

  get periodResourceSac() {
      return this.periodCollectionNoWeekly.get(this.period)
  }
  set periodResourceSac(val: IResource | null) {
      this.period = val && val.$id as Period || Period.DAILY
  }

  get dayResource() {
    return this.dayCollection.get(this.day)
  }
  set dayResource(val: IResource | null) {
    this.day = val && val.$id as number || moment().date()
  }

  get monthResource() {
    return this.monthCollection.get(this.month)
  }
  set monthResource(val: IResource | null) {
    this.month = val && val.$id as number || moment().month()
  }

  get yearResource() {
    return this.yearCollection.get(this.year)
  }
  set yearResource(val: IResource | null) {
    this.year = val && val.$id as number || moment().year()
  }

  get day() {
    return Number(moment(this.date).format('DD')) || 0
  }
  set day(val: number) {
    this.date = moment(this.date).date(val).format()
  }

  get month() {
    return Number(moment(this.date).format('MM')) || 0
  }
  set month(val: number) {
    this.date = moment(this.date).month(val - 1).format()
  }

  get year() {
    return Number(moment(this.date).format('YYYY')) || 0
  }
  set year(val: number) {
    this.date = moment(this.date).year(val).format()
  }

  get insumoResource() {
    return this.allCentroDeCusto.get(this.idInsumo)
  }
  set insumoCustoResource(val: IResource | null) {
    this.idInsumo = val && val.$id as number || null
  }

  get cteResource() {
    const str = String(this.searchByCTE || '')
    const cte = str.split(',')
    return this.allCte.getMany(cte)
  }
  set cteResource(val: IResource[]) {
    this.searchByCTE = val.map((item: IResource) => item.$id).join(',')
  }

  clean() {
    this.documentDestinatario = null
    this.docs = null
    this.idTipoOcorrencia = null
    this.idCarga = null
    this.nomeDestinatario = null
  }

  cleanSearchByCTE() {
    this.searchByCTE = ''
  }

  populateSearchByCTE(val: IResource[]) {
    this.allCte = new ObjectCollection(val)
  }
}
